<app-header id="header" [sideNav]="sideNav"></app-header>
<app-sidenav #sideNav>
  <router-outlet></router-outlet>
</app-sidenav>


